import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import ua from '@tencent/docs-user-agent';
import { IS_ENTERPRISE } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { AppEntryType } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';

// 代码环境
enum EEnv {
    PRODUCTION = 'production',
    TEST = 'test',
    DEVELOPMENT = 'development'
}

// 设备环境
enum EDevice {
    PC = 'pc',
    MOBILE = 'mobile',
    PAD = 'pad'
}

// 平台
enum EPlatform {
    MAC = 'mac',
    WINDOWS = 'windows',
    IOS = 'ios',
    ANDROID = 'android',
    OTHER = 'other'
}

// app
enum EApp {
    WECHART = 'weChart',
    WXWORK = 'wxwork',
    QQ = 'qq',
    TDOCS = 'tDocs',
    TDAPPDESKTOP = 'tdAppDesktop',
    MEETING = 'meeting',
    BROWSERS = 'browsers',
}

/**
 * 获取当前所处代码环境
 * 线上/测试（包括预发布）/本地开发
 */
const getEnv = function (): EEnv {
    if (ENV.IS_RELEASE) {
        return EEnv.PRODUCTION;
    }
    if (ENV.IS_TEST) {
        return EEnv.TEST;
    }
    return EEnv.DEVELOPMENT;
};

/**
 * 获取当前代码版本，非dws服务下的都为本地开发
 */
const getCodeVersion = function (): string {
    return global.__DWS_INFO__?.releaseVersion || 'development';
};

/**
 * 获取当前设备类型
 * 移动端/PC端/PAD
 */
const getDevice = function (): EDevice {
    if (browser.isPad) {
        return EDevice.PAD;
    }
    if (browser.isMobile) {
        return EDevice.MOBILE;
    }
    return EDevice.PC;
};

/**
 * 当前所处平台
 * MAC/WINDOWS/IOS/ANDROID/其他
 */
const getPlatform = function (): EPlatform {
    if (browser.isMac) {
        return EPlatform.MAC;
    }
    if (browser.isWindows) {
        return EPlatform.WINDOWS;
    }
    if (browser.isIOS) {
        return EPlatform.IOS;
    }
    if (browser.isAndroid) {
        return EPlatform.ANDROID;
    }
    return EPlatform.OTHER;
};

/**
 * 当前所处APP
 * 微信/企微/QQ/腾讯文档客户端/腾讯文档桌面端/腾讯会议/普通浏览器
 */
export const getApp = function (): EApp {
    if (browser.isWeChat) {
        return EApp.WECHART;
    }
    if (browser.isWxWork) {
        return EApp.WXWORK;
    }
    if (browser.isQQ) {
        return EApp.QQ;
    }
    if (browser.isTencentDocApp) {
        return EApp.TDOCS;
    }
    if (browser.isTencentDocDesktopApp) {
        return EApp.TDAPPDESKTOP;
    }
    if (ua.isTencentMeeting) {
        return EApp.MEETING;
    }
    return EApp.BROWSERS;
};

/**
 * 是否为B端代码
 */
const isEnterprise = function (): boolean {
    return !!IS_ENTERPRISE;
};


/**
 * 是否为小程序（不区分微信还是QQ）
 */
export const isMiniProgram = function (): boolean {
    return browser.isMiniProgram;
};

// 缓存环境信息
const extDataCache: any = {};

/**
 * 获取各种基础信息
 */
export const getCommonExtData = function (options?: { appEntryType: AppEntryType }) {
    if (options) {
        const { appEntryType } = options;
        extDataCache.appEntryType = appEntryType; // 代码入口：pc/mobile/meeting/player，上层的入口信息，只能一层一层的传到infrastructure层
    }
    const getFnMap = {
        env: getEnv, // 线上/测试（包括预发布）/本地开发
        codeVersion: getCodeVersion, // 获取当前代码版本
        device: getDevice, // 移动端/PC端/PAD
        platform: getPlatform, // MAC/WINDOWS/IOS/ANDROID/其他
        app: getApp, // 微信/企微/QQ/腾讯文档客户端/腾讯文档桌面端/腾讯会议/普通浏览器
        isEnterprise, // 是否为B端代码
        isMiniProgram, // 是否为小程序（不区分微信还是QQ）
        isVer3: () => true, // 是否为3.0
        isLocalEdit: () => ENV.IS_LOCAL_EDIT, // 是否为本地文档
    };
    Object.keys(getFnMap).forEach((p) => {
        if (extDataCache[p] === undefined) {
            extDataCache[p] = getFnMap[p]();
        }
    });
    return extDataCache;
};
